module.exports = __webpack_public_path__ + "img/videowiki.ca7d1116.svg";